module.exports = __webpack_public_path__ + "static/media/Logo_monocromático blanco720.b885bb58.png";